import React, { useEffect } from 'react'
import Header from './header'
import Footer from './footer'
import { Outlet, useLocation } from 'react-router-dom'
import ChatBubble from './ChatBubble'

const Layout = () => {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, [location.pathname]); // Runs when the URL path changes

    return (
        <div>
            <Header />
            <Outlet />
            <Footer />
            <ChatBubble />
        </div>
    )
}

export default Layout
// filepath: d:\All Senew Tech Projects\westbreeze\src\layout\index.js
